
import Game from "./Components/Game";
import Dropdown from './Components/Dropdown';
import { NOVICE, INTERMEDIATE, EXPERT} from './Constants/SkillLevel';
import { useState } from 'react';
import { Pause } from './GameFunctions/MiscGameFunctions';

function App() {
    const [onePlayerGame, setOnePlayerGame] = useState(false);
    const [stepNumber, setStepNumber] = useState(0);
    const [xIsNext, setXIsNext] = useState(true);
    const [skillLevel, setSkillLevel] = useState("");
    const [gameStarted, setGameStarted] = useState(false);
    const [readyToPlay, setReadyToPlay] = useState(false);
    const [noOfPlayersSelection, setNoOfPlayersSelection] = useState(null);
    const [skillSelection, setSkillSelection] = useState(null);
    const [history, setHistory] = useState([{   // history stores the board after every move in the game so we can go back in time
      squares: Array(9).fill(null)              // creating an array of squares to store the game history
    }]);
    const playerSelectionText = <p>Select two players if you will be sharing a smartphone or tablet with a friend. <br /> If you select one player you will be playing against the computer</p>;

    let pageHeader = 
      <>
        <h6 className='pre-heading'>Welcome To</h6>
        <h2 className="heading"> PHIL'S TIC-TAC-TOE</h2> 
        <span className='version-info'> Version 4.5.0 </span>
        <span className='version-info'> 05-07-2023 </span>
        <br />
      </>;

    const skillOptions = [
      { label: 'Novice', value: NOVICE},
      { label: 'Intermediate', value: INTERMEDIATE},
      { label: 'Expert', value: EXPERT}
    ];     
  
    const playerOptions = [
      { label: 'One', value: 'one'},
      { label: 'Two', value: 'two'}
    ];

    const handleGameStart = (option) => {
      setGameStarted(true);
    };

    const handleNumOfPlayers = (option) => {
      setNoOfPlayersSelection(option);
      if (option.value === "one") {
        setOnePlayerGame(true);
        setReadyToPlay(false);
        Pause();
      } else {
        setOnePlayerGame(false);
        setReadyToPlay(true);
        Pause();
      }
    }
  
    const handleSkillSelect = (option) => {
      setSkillSelection(option);   
      setSkillLevel(option.value);
      setReadyToPlay(true);  
    }
// "Select two players if you will be sharing a smartphone or tablet with a friend. If you select one player you will be playing against the computer. "
    return (
        <div>
        {pageHeader}
        <div className="dropdown-panel" >
          {!gameStarted &&
          <div className="game-options">
            <div className="options-dropdown" >
              <Dropdown
                options={playerOptions} 
                value={noOfPlayersSelection} 
                onChange={handleNumOfPlayers} 
                label={playerSelectionText}>
              </Dropdown>
            </div>
            <div className="options-dropdown">
              {onePlayerGame && 
              <Dropdown
                options={skillOptions} 
                value={skillSelection} 
                onChange={handleSkillSelect} 
                label="Choose the skill level for the computer.">
              </Dropdown>}    
            </div>      
          </div>}
          <div className="start-game-div">
              { readyToPlay && !gameStarted && 
              <button 
              onClick={handleGameStart} className="start-game-button">Start Game</button>}
        </div>  
        </div>   
   
        <div>
            {gameStarted && 
            <Game 
            onePlayerGame = {onePlayerGame} 
            history={history} 
            setHistory={setHistory} 
            stepNumber = {stepNumber}
            setStepNumber = {setStepNumber}
            xIsNext = {xIsNext}
            setXIsNext = {setXIsNext}
            skillLevel={skillLevel} />}
        </div>
      </div>
    );

};

export default App;